import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import {
  getPublishedListingsThunk,
  getPublishedListingsTotalThunk,
} from './thunks'

const publishedListingsSlice = createSlice({
  name: 'publishedListings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPublishedListingsThunk.pending, (state, action) => {
      state.fetching = true

      const nextSearch = action.meta.arg?.search ?? ''
      const nextTransactionType = action.meta.arg?.transactionType ?? ''
      const nextSort = action.meta.arg?.sort ?? state.sort
      const shouldClearListings =
        nextSearch !== state.search ||
        nextTransactionType !== state.transactionType ||
        nextSort !== state.sort
      const shouldReset = !action.meta.arg?.skip || shouldClearListings

      if (shouldReset) {
        state.hasMore = true
        state.skip = 0
        if (shouldClearListings) {
          state.listings = []
        }
        state.loaded = false
      }
    })
    builder.addCase(getPublishedListingsThunk.fulfilled, (state, action) => {
      const {
        listings,
        skip = 0,
        count,
        search,
        transactionType,
        sort,
        total,
      } = action.payload

      if (!skip) {
        state.listings = listings
      } else {
        const existingIds = new Set(state.listings.map((listing) => listing.id))
        const newListings = listings.filter(
          (listing) => !existingIds.has(listing.id)
        )
        state.listings = [...state.listings, ...newListings]
      }

      state.fetching = false
      state.loaded = true
      state.skip = skip + listings.length
      state.pageSize = count ?? state.pageSize
      state.hasMore = listings.length === (count ?? state.pageSize)
      state.search = search ?? ''
      state.transactionType = transactionType ?? ''
      state.sort = sort ?? state.sort
      if (typeof total === 'number') {
        state.total = total
      }
    })
    builder.addCase(getPublishedListingsThunk.rejected, (state) => {
      state.fetching = false
    })
    builder.addCase(getPublishedListingsTotalThunk.pending, (state) => {
      state.totalFetching = true
    })
    builder.addCase(
      getPublishedListingsTotalThunk.fulfilled,
      (state, action) => {
        state.totalAvailable = action.payload
        state.totalFetching = false
        state.totalLoaded = true
      }
    )
    builder.addCase(getPublishedListingsTotalThunk.rejected, (state) => {
      state.totalFetching = false
      state.totalLoaded = true
      state.totalAvailable = 0
    })
  },
})

export default publishedListingsSlice.reducer
